import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css']
})
export class StateComponent implements OnInit {
  stateForm: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
  pageNo: any;
  searchStr:any='';
	modalTitle: any;
  categoryList: any;
	countryList: any;
  stateList: any;
  optionSelected: any;
	isStateAvailable:boolean=true;
	btnTitle: any;
  selectedCategoryId: any;
  selectedStateId:any
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	profession: any;
	surveyCategoryList: any;
	category_id: any;
	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }
		

	ngOnInit() {
		//this.commonService.setTitle();
		$(".navbar-brand").text("State");
	//	$(".navbar-brand").text("category_id");
		this.stateForm = new FormGroup({
			state: new FormControl("", Validators.compose([
				Validators.required,
			])),
      country_id: new FormControl("",Validators.compose([
				Validators.required
			])),
    });

	
		// this.professionForm = new FormGroup({
		// 	category_id: new FormControl("", Validators.compose([
		// 		Validators.required,
		// 	])),
		// });
  
    this.pageNo = 1;
    this.limit = 10;
    this.getStateList(this.pageNo, this.limit, this.searchStr);
		//this.getCategoryList(this.pageNo, this.limit);
    //this.initialiseSurvey();
    
        
    this.getCountryList();
   
			
  }
  
 

	// initialiseSurvey = function () {
	// // Get survey category list
	// this.authService.getSurveyCategoryList().subscribe(data => {
	// 	if (data.success) {
		
	// 		this.surveyCategoryList = data.category;
	// 		setTimeout(() => {
	// 			//if (obj.survey_category_id)
	// 				//this.professionForm.controls['category_id'].setValue(data._id);
	// 		//	 $('.select_lang').removeClass('is-empty');
	// 		}, 10);
	// 	}
	// });
  // }
  


  	// Get Country list
	getCountryList = function (){
   
//this.commonService.process();
this.authService.getCountryList().subscribe(data=>{
if(data.success) {

//this.isCountryAvailable=true;
        // debugger;;
this.countryList = data.country;
console.log(data)

//this.total = data.total;
// this.setPage(pageNo, true);
// this.pageNo = pageNo;
}

else{
this.isCountryAvailable=false;
this.countryList = [];
// this.countrycodeList = [];
}

this.commonService.hideProcess();
      // debugger;;
});
}


	// Get profession List
	// getCategoryList = function (page, limit) {
	// 	        // debugger;;
	// 	this.commonService.process();
	// 	this.authService.getProfessionList(page, limit).subscribe(data => {
	// 		if (data.success) {
	// 			this.categoryList = data.profession;
	// 			this.total = data.total;
	// 			this.setPage(page, true);
	// 			this.pageNo = page;
	// 		}
	// 		console.log(data.profession)
	// 		this.commonService.hideProcess();
	// 	});
  // }
  
  // Get State List
	getStateList = function (pageNo, limit, SeachStr) {
  ;
this.commonService.process();

this.authService.getStateList(pageNo, limit, SeachStr).subscribe(data => {
if (data.success) {
	this.isStateAvailable=true;
  
this.stateList = data.state;
console.log(this.stateList)
this.total = data.total;
console.log(data)
 this.setPage(pageNo, true);
 this.pageNo = pageNo;
}

else{
	this.isStateAvailable=false;
	this.stateList = [];
	// this.countrycodeList = [];
}


this.commonService.hideProcess();
});
}

	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.stateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getStateList(page, this.limit, this.searchStr);
		}
	}

	// Add State
	addState = function () {

    
		this.isActivatedAdd = true;
		this.isActivatedEdit = false;
		this.isActivatedDelete = false;
		this.modalTitle = "Add State";
    this.btnTitle = "Save";
    this.selectedCategoryId = "";
    this.stateForm.reset();
	
		
	}

	// Update selected State
	updateSelectedState = function (state) {

		this.isActivatedAdd = false;
		this.isActivatedEdit = true;
		this.isActivatedDelete = false;
		this.modalTitle = "Update State";
		this.btnTitle = "Update";
		this.selectedStateId = state._id;
    this.stateForm.controls['state'].setValue(state.state);
		this.stateForm.controls['country_id'].setValue(state.country_id._id)
	}

	// Delete Selected state
	deleteSelectedState = function (state) {

	
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete State";
		this.btnTitle = "Yes";
		this.selectedStateId = state._id;
		this.state = state;
	}

	// manage new profession
	manageState = function (stateForm,) {
debugger;
		if (this.stateForm.valid && this.isActivatedAdd) {
			this.btnTitle = "Saving...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			         
			this.authService.manageState(stateForm, "add").subscribe(data => {
				if (data.success) {
          
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.getStateList(1, this.limit, this.searchStr);
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.stateForm.valid && this.isActivatedEdit) {
 
			stateForm._id = this.selectedStateId;
			this.btnTitle = "Updating...";
      jQuery(':button[type="submit"]').attr('disabled', true);
     
			this.authService.manageState(stateForm, "edit", this.selectedStateId).subscribe(data => {
      
				if (data.success) {	
        debugger;
					this.getStateList(this.pageNo, this.limit,this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.isActivatedDelete) {
;
			stateForm._id = this.selectedStateId;
			this.btnTitle = "Deleting...";	
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageState(stateForm, "delete", this.selectedStateId).subscribe(data => {

				if (data.success) {	
        
					this.getStateList(this.pageNo, this.limit);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.stateForm);
		}
	}


	// Search State
	searchState = function(){
		this.searchStr = jQuery("#search").val();
		this.getStateList(1, this.limit, this.searchStr);
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/state/state.component.ts